import React, { useEffect, useState } from "react";
import { Typography, Row, Col, Card, Button, Collapse, Switch, InputNumber } from "antd";
import {
  CheckOutlined,
  TagFilled,
  FireOutlined,
  UpOutlined,
  DownOutlined,
  ArrowRightOutlined,
} from "@ant-design/icons";
import { plans, bundles, VIEW_MODAL_DICT } from "../../data/data";
import "./Plans.scss";
import WhatYouGet from "../WhatYouGet/WhatYouGet";
import * as ENVIRONMENT from '../../../../env.js'

const { Paragraph } = Typography;

const SubscriptionSelector = ({ selectedPlan, setSelectedPlan }) => {
  return (
    <div className="subscription-selector-wrapper">
      <div className="subscription-selector">
        <div
          className={`plan ${selectedPlan === "subscriptions" ? "selected" : ""
            }`}
          onClick={() => setSelectedPlan("subscriptions")}
        >
          <span className=" manrope f-14 w-700 lh-22">Subscriptions</span>
          <span className="manrope f-12 w-400 lh-20">Best value</span>
        </div>
        <div
          className={`plan ${selectedPlan === "bundles" ? "selected" : ""}`}
          onClick={() => setSelectedPlan("bundles")}
        >
          <span className="manrope f-14 w-700 lh-22">Packages</span>
          <span className="manrope f-12 w-400 lh-20">Buy as needed</span>
        </div>
      </div>
    </div>
  );
};

const FeatureList = ({ features, feature_tag }) => (
  <ul>
    {features.map((feature, i) => (
      <li key={i} className="justify-space-between">
        <div className="justify-in-start-align-baseline">
          <CheckOutlined className="manrope blue w-700 mr-10" />
          <span className="manrope f-14 black-085 lh-22">{feature}</span>
        </div>
        <div className="beta-bg-tag">{feature_tag[i]}</div>
      </li>
    ))}
  </ul>
);

const TableData = ({ tableData }) => (
  <div className="table-data">
    {tableData.map((data, i) => (
      <span key={i} className="table-row">
        <span className="service">{data.service}</span>
        <input className="value" type="number" value={data.value} readOnly />
      </span>
    ))}
  </div>
);

const PlanCard = ({ plan, index, setSelectedOffer }) => {
  const [switchState, setSwitchState] = useState({
    "Starter": false,
    "Growth": false,
    "Free": false,
    "Enterprise": false
  });

  const utm_source = localStorage.getItem("utm_source") || "";

  const renderFeatures = <FeatureList feature_tag={plan.feature_tag} features={switchState[plan.package_type] ? plan.enhanced_features : plan.features} />;

  const renderTableData = <TableData tableData={plan.tableData} />;

  const renderMobileFeatures = (
    <Collapse
      expandIconPosition="right"
      expandIcon={({ isActive }) =>
        isActive ? <UpOutlined /> : <DownOutlined />
      }
    >
      <Collapse.Panel
        header={<span className="manrope f-14 w-700 black-085">{plan.featuresHeading}</span>}
        key="1"
      >
        {plan.tableData && renderTableData}
        <div className="features">{renderFeatures}</div>
      </Collapse.Panel>
    </Collapse>
  );

  const handleSwitchChange = (checked, package_type) => {
    setSwitchState((prev) => ({
      ...prev,
      [package_type]: checked, // Toggle only the selected plan
    }));
  }

  const openViewOfferModal = () => {
    let offer_type = VIEW_MODAL_DICT[plan.package_type];
    if ((plan.package_type == "Growth" && switchState[plan.package_type]) || (plan.package_type == "Starter" && switchState[plan.package_type])) {
      offer_type = VIEW_MODAL_DICT[plan.package_type + "+"];
    }
    console.log(plan.package_type, offer_type)
    setSelectedOffer(offer_type);
  }

  return (
    <Col xs={24} sm={12} md={12} lg={6} key={index} className={`halo-outline ${plan.package_type == 'Growth' ? `yellow pdb-12` : `transparent`}`} style={{ padding: `${plan.package_type == 'Growth' ? `12px` : `8px`} 12px 8px 12px` }}>
      {plan.package_type == 'Growth' ?
        <div className="justify-in-center mb-10">
          <img src="/Thunderbolt.svg" />
          <div className="manrope f-12 lh-20 w-700 orange-AD ml-2">AMAZON & SHOPIFY READY</div>
        </div> : ''}
      <Card className="plan-card" bordered={false}>
        <div className="card-content">
          <span className="card-subtitle manrope f-14 w-500">{plan.subtitle}</span>
          <span className="card-title manrope f-20 w-700">{plan.title}{switchState[plan.package_type] ? "+" : ''}</span>
          <Paragraph className="card-description manrope f-14 w-500 lh-22">
            {plan.description}
            {plan.discount && (
              <div className="discount-wrapper">
                <TagFilled className="discount-icon" />
                <Paragraph className="discount manrope f-12 w-500">{plan.discount}</Paragraph>
              </div>
            )}
          </Paragraph>
          <div className={`card-price manrope f-24 w-700 a-baseline ${plan.package_type == "Growth" || plan.package_type == "Starter" ? "mt-0" : ""}`}>
            {switchState[plan.package_type] ? plan.price_plus : plan.price}
            <div className="annual-period">{plan.annualPeriod}</div>
          </div>
          <Paragraph className="monthly-period manrope f-14 w-400">{switchState[plan.package_type] ? plan.monthlyPlusPeriod : plan.monthlyPeriod}</Paragraph>
          <Button
            className={`${plan.buttonClassName ? plan.buttonClassName : ''} card-button manrope f-16 w-600 lh-24`}
            block
            style={{marginTop: plan.package_type == 'Enterprise' || plan.package_type == 'Free' ? 5 : 0}}
            onClick={() => {
              if(plan.plan_name == 'enterprise')
                window.open(`${ENVIRONMENT.PORTAL_BASE_URL}/register?redirectURL=${encodeURIComponent(`/select-subscription?plan=free_trial&plan_type=subscription&is_enterprise=true&utm_source=${utm_source}`)}`, "_blank")
              else
                window.open(`${ENVIRONMENT.PORTAL_BASE_URL}/register?redirectURL=${encodeURIComponent(`/select-subscription?plan=${switchState[plan.package_type] ? plan.plan_plus_name : plan.plan_name}&plan_type=subscription&utm_source=${utm_source}`)}`, "_blank")
            }}
          >
            {`${switchState[plan.package_type] ? plan.buttonText + '+' : plan.buttonText}`}
          </Button>
          {plan.get_more_toggle ?
            <div className="justify-space-between mt-17">
              <div className="manrope f-12 w-500 black-085">{plan.get_more_text} <span className="manrope f-12 w-700 black-085">{plan.package_type}+</span></div>
              <Switch checked={switchState[plan.package_type]} onChange={(checked) => handleSwitchChange(checked, plan.package_type)} />
            </div> : ''}
            {(plan.package_type == 'Enterprise') ?
            <div className="enterprise-height"></div> : (plan.package_type == 'Growth') ?
            <div className="growth-height"></div> : ''}
        </div>


        <div className="features-wrapper">
          {/* Desktop view */}
          <div className="desktop-features hidden md:block">
            <>
              <span className="features-heading manrope f-14 w-700">{plan.featuresHeading}</span>
              <div className="features manrope f-14 w-500">{renderFeatures}</div>

              {plan.featuresHeadingSection2 != undefined ?
                <>
                  <span className="features-heading manrope f-14 w-700">{plan.featuresHeadingSection2}</span>
                  <div className="features manrope f-14 w-500"><FeatureList features={switchState[plan.package_type] ? plan.enhanced_features_2 : plan.featuresSection2} feature_tag={plan.feature_tag2} /> </div>
                </> : ''
              }
              {plan.additional_desc ?
                <div className="manrope f-12 w-400 black-085 lh-20">{plan.additional_desc}</div> : ''}
            </>
          </div>

          {/* Mobile view */}
          <div className="mobile-features md:hidden">
            {renderMobileFeatures}
          </div>
        </div>
        <div className="justify-space-between view-cta">
          <div className="cursor pointer manrope f-14 w-500 blue" onClick={openViewOfferModal}>
            View what you get
          </div>
          <ArrowRightOutlined onClick={openViewOfferModal} className="cursor pointer manrope f-14 w-500 blue" />
        </div>
      </Card>
    </Col>
  );
};

const BundleCard = ({ bundle, index, setSelectedOffer, quantity, setQuantity }) => {
  const [price, setPrice] = useState({
    "AI Creator": 14,
    "PDP Basic": 139,
    "PDP Pro": 399,
  });
  const [totalPrice, setTotalPrice] = useState({});

  const handleQuantityChange = (value, packageType) => {
    setQuantity((prev) => ({
      ...prev,
      [packageType]: value,
    }));

    setTotalPrice((prev) => ({
      ...prev,
      [packageType]: (value || 0) * price[packageType], // Multiply price with quantity
    }));
  };

  const renderFeatures = <FeatureList feature_tag={bundle.feature_tag} features={bundle.features} />;
  const renderMobileFeatures = (
    <Collapse
      expandIconPosition="right"
      expandIcon={({ isActive }) =>
        isActive ? <UpOutlined /> : <DownOutlined />
      }
    >
      <Collapse.Panel header={bundle.featuresHeading} key="1">
        <div className="features">{renderFeatures}</div>
      </Collapse.Panel>
    </Collapse>
  );

  const openViewOfferModal = () => {
    setSelectedOffer(VIEW_MODAL_DICT[bundle.package_type])
  }

  const allowedKeys = [
    'Backspace',
    'Delete',
    'ArrowLeft',
    'ArrowRight',
  ];
  const utm_source = localStorage.getItem("utm_source") || "";

  return (
    <Card className="plan-card">
      <div className="card-content">
        {bundle.alert ? (
          <span className="bundle-alert manrope f-14 w-500">
            <FireOutlined className="fire-icon" />
            <span> {bundle.alert}</span>
          </span>
        ) : (
          <div className="no-alert" />
        )}

        <span className="card-title bundle manrope f-20 w-700 black-085">{bundle.title}</span>
        <Paragraph className="card-description bundle manrope f-14 w-500 black-085 lh-22 mb-0">
          {bundle.description}
        </Paragraph>
        <div className="justify-space-between align-baseline wrap-flex">
          <div>
            <span className="card-price manrope f-26 black-085 w-700 a-baseline">
              ${bundle.price}
              <span className="annual-period manrope f-14 w-400 black-085 lh-22">/product</span>
            </span>
          </div>
          <div className="justify-in-end">
            <div className="manrope f-10 lh-22 black-085 w-500 mr-8">QTY</div>
            <InputNumber min={1}
              onKeyDown={(e) => {
                if ((["-", ".", " "].includes(e.key)) || (/[a-zA-Z\s]/.test(e.key) && !allowedKeys.includes(e.key))) {
                  e.preventDefault();
                }
              }}
              value={quantity[bundle.title] || 1}
              onChange={(value) => handleQuantityChange(value, bundle.title)}
              className="manrope f-14 lh-22 black-085 w-400" />
          </div>
        </div>
        <Paragraph className="monthly-period manrope f-14 lh-22 w-400 black-085">One-time purchase</Paragraph>

        <Button className={`card-button manrope f-16 w-600 lh-24`} block onClick={() => {
          window.open(`${ENVIRONMENT.PORTAL_BASE_URL}/register?redirectURL=${encodeURIComponent(`/select-subscription?plan=${bundle.name}&plan_type=bundle&quantity=${quantity[bundle.title] || 1}&utm_source=${utm_source}`)}`, "_blank")
        }}>
          {bundle.buttonText}
        </Button>
      </div>

      <div className="features-wrapper">
        {/* Desktop view */}
        <div className="desktop-features hidden md:block">
          <div className="features">
            <span className="features-heading manrope f-14 w-700">{bundle.featuresHeading}</span>
            {renderFeatures}

            {bundle.featuresHeadingSection2 != undefined ?
              <>
                <span className="features-heading">{bundle.featuresHeadingSection2}</span>
                <FeatureList feature_tag={bundle.feature_tag} features={bundle.featuresSection2} />
              </> : ''
            }
          </div>
          {bundle.additional_desc ?
            <div className="manrope f-12 w-400 black-085 lh-20">{bundle.additional_desc}</div> : ''}

        </div>

        {/* Mobile view */}
        <div className="mobile-features md:hidden">
          {renderMobileFeatures}
        </div>

      </div>
      <div className="justify-space-between view-cta">
        <div className="cursor pointer manrope f-14 w-500 blue" onClick={openViewOfferModal}>
          View what you get
        </div>
        <ArrowRightOutlined onClick={openViewOfferModal} className="cursor pointer manrope f-14 w-500 blue" />
      </div>
    </Card>
  );
};

const Plans = () => {
  const [selectedPlan, setSelectedPlan] = useState("subscriptions");
  const [selectedOffer, setSelectedOffer] = useState('');
  const [quantity, setQuantity] = useState({});

  return (
    <div className="pricing-plans-wrapper">
      <div className="pricing-plans">
        <span className="manrope f-50 w-600 lh-60 mb-20 heading-pricing">
          Flexible pricing to bring your listings to life with AI-powered 3D
        </span>
        <Paragraph className="description manrope f-16 w-500 lh-24">
          Find the perfect plan to create 3D models and 4K product images that showcase your products.
        </Paragraph>

        <SubscriptionSelector
          selectedPlan={selectedPlan}
          setSelectedPlan={setSelectedPlan}
        />

        {selectedPlan === "subscriptions" ? (
          <>
            <Row gutter={[16, 16]}>
              {plans.map((plan, index) => (
                <PlanCard key={index} plan={plan} index={index} setSelectedOffer={setSelectedOffer} />
              ))}
            </Row>
            <Paragraph className="footnote manrope f-14 black-085 w-500 lh-22">
              Growth and Growth+ include any combination of listed 3D services within your paid quota for the month and do not roll over. All subscriptions are annual–you may unsubscribe at any time with a 30 day notice.{" "}
              <a href="#faqs" className="footnote-link manrope f-14 w-700">See FAQs</a>
            </Paragraph>
          </>
        ) : (
          <>
            <Row gutter={[16, 16]} className="hide-mid-screen">
              {bundles.map((bundle, index) => (
                (bundle.title != "PDP Basic" && bundle.title != "PDP Pro") &&
                <Col xs={24} sm={12} md={12} lg={7} key={index} className="halo-outline transparent pdt-36" style={{ paddingBottom: 35}}>
                  <BundleCard quantity={quantity} setQuantity={setQuantity} key={index} bundle={bundle} index={index} setSelectedOffer={setSelectedOffer} />
                </Col>
              ))}
              <Col xs={24} sm={12} md={12} lg={14} className="halo-outline yellow bundle-col amazon-listing-text-pd">
                <div className="justify-in-center">
                  <img src="/Thunderbolt.svg" />
                  <div className="manrope f-12 lh-20 w-700 orange-AD ml-2">AMAZON & SHOPIFY READY</div>
                </div>
                <Row className="j-start-a-start wrap-flex">
                  {bundles.map((bundle, index) => (
                    (bundle.title == "PDP Basic" || bundle.title == "PDP Pro") &&
                    <Col xs={24} sm={24} md={24} lg={12} key={index} style={{ padding: "8px 12px 0px 12px" }} className="plans-height">
                      <BundleCard quantity={quantity} setQuantity={setQuantity} key={index} bundle={bundle} index={index} setSelectedOffer={setSelectedOffer} />
                    </Col>
                  ))}
                </Row>
                <div className="justify-in-center plans-shopify-text">
                  <div className="manrope f-12 lh-20 w-400 orange-AD">See 3D model integration requirements for <b>Amazon</b> and <b>Shopify</b> listings.</div>
                </div>
              </Col>
            </Row>
            <Row gutter={[16, 16]} className="show-mid-screen">
              {bundles.map((bundle, index) => (
                (bundle.title != "PDP Basic" && bundle.title != "PDP Pro") &&
                <Col xs={24} sm={12} md={12} lg={7} key={index} className="halo-outline transparent pdt-36">
                  <BundleCard quantity={quantity} setQuantity={setQuantity} key={index} bundle={bundle} index={index} setSelectedOffer={setSelectedOffer} />
                </Col>
              ))}

              {bundles.map((bundle, index) => (
                (bundle.title == "PDP Basic" || bundle.title == "PDP Pro") &&
                <Col xs={24} sm={12} md={12} lg={7} key={index} style={{ padding: 8 }} className="halo-outline yellow">
                  <div className="justify-in-center mb-10">
                    <img src="/Thunderbolt.svg" />
                    <div className="manrope f-12 lh-20 w-700 orange-AD ml-2">AMAZON & SHOPIFY READY</div>
                  </div>
                  <BundleCard quantity={quantity} setQuantity={setQuantity} key={index} bundle={bundle} index={index} />
                  <div className="justify-in-center mt-10">
                    <div className="manrope f-12 lh-20 w-400 orange-AD">See 3D model integration requirements for <b>Amazon</b> and <b>Shopify</b> listings.</div>
                  </div>
                </Col>
              ))}
            </Row>
            <Paragraph className="footnote manrope f-14 black-085 w-500 lh-22">
              Each package is priced per product/SKU. You may update the quantity needed in checkout.{" "}
              <a href="#faqs" className="footnote-link manrope f-14 w-700">See FAQs</a>
            </Paragraph>
          </>
        )}
      </div>
      <WhatYouGet
        quantity={quantity}
        selectedOffer={selectedOffer}
        setSelectedOffer={setSelectedOffer}
        selectedPlan={selectedPlan} />
    </div>
  );
};

export default Plans;
